// extracted by css-extract-rspack-plugin
export default {"item":"_39ca7bbf","imageWrapper":"_e600d11e","image":"_6057860d","title":"_a4662fca"};